import { useIntl } from 'react-intl'

const useTranslate = () => {
  const { formatMessage } = useIntl()

  const translate = (id) => formatMessage({ id })

  return translate
}

export default useTranslate
